module.exports = __webpack_public_path__ + "img/maximix-web.4681c56.png";